export default __webpack_public_path__ + "static/media/slide1.bcf17219.jpg";